module.exports = __webpack_public_path__ + "static/1-80bbd56b1bf7bcb2472ff62cf47b53dd.webp";